module.exports = __webpack_public_path__ + "static/media/32.1dbb8795.jpg";